import React, { useState, useRef } from "react";
import emailjs from "emailjs-com";
import "./ContactUs.css";

const initialState = {
  name: "",
  mobile: "",
  service: "",
  pincode: "",
  address: "",
};

const ContactUs = () => {
  const [formData, setFormData] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const formRef = useRef();

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateMobile = (mobile) => {
    return /^[0-9]{10}$/.test(mobile);
  };

  const clearForm = () => {
    setFormData(initialState);
    formRef.current.reset();
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateMobile(formData.mobile)) {
      alert("Please enter a valid 10-digit mobile number");
      return;
    }

    setLoading(true);

    emailjs
      .sendForm(
        "service_sj7kiys",
        "template_zzkbfgs",
        formRef.current,
        "GXxgE1_ku99xodHdX"
      )
      .then(() => {
        alert(
          "Thank you! Your callback request has been submitted successfully."
        );
        clearForm();
      })
      .catch((error) => {
        console.error(error);
        alert("Something went wrong. Please try again.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <section className="contact-section">
      <div className="contact-container">
        {/* Left Content */}
        <div className="contact-info">
          <span className="contact-tag">Contact Us</span>

          <h1>
            Request a <span>Callback</span>
          </h1>

          <p>
            Have questions or need assistance? Fill out the form and our team
            will contact you shortly.
          </p>

          <div className="info-box">
            <div className="info-item">
              <h4>📞 Phone</h4>
              <p>18005711030</p>
            </div>

            <div className="info-item">
              <h4>📧 Email</h4>
              <p>yuvrajaquacare1@gmail.com</p>
            </div>
          </div>
        </div>

        {/* Form */}
        <div className="contact-card">
          <form ref={formRef} onSubmit={handleSubmit}>
            <div className="form-row">
              <input
                type="text"
                name="name"
                placeholder="Full Name*"
                required
                onChange={handleChange}
              />

              <input
                type="tel"
                name="mobile"
                placeholder="Mobile Number*"
                required
                onChange={handleChange}
              />
            </div>

            <div className="form-row">
              <select
                name="service"
                required
                value={formData.service}
                onChange={handleChange}
              >
                <option value="">Choose Service</option>
                <option value="routine-checkup">
                  RO Routine Checkup
                </option>
                <option value="repair-service">
                  RO Repair Service
                </option>
                <option value="installation-service">
                  RO Installation Service
                </option>
                <option value="change-filter-inside-machine">
                  Change Filter (Inside Machine)
                </option>
                <option value="change-filter-outside-machine">
                  Change Filter (Outside Machine)
                </option>
                <option value="inspection-and-estimate">
                  RO Inspection and Estimate
                </option>
              </select>

              <input
                type="number"
                name="pincode"
                placeholder="Pincode*"
                required
                onChange={handleChange}
              />
            </div>

            <textarea
              name="address"
              rows="4"
              placeholder="Address*"
              required
              onChange={handleChange}
            />

            <button type="submit" disabled={loading}>
              {loading ? "Sending..." : "Request Callback"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;